module.exports = __webpack_public_path__ + "img/banner-bg-4.4316acdd.png";